<template>
    <div id="SupplyChainJoin" class="w3 w90-mb">
        <h1 class="h1">加入循環供應鏈</h1>
        <ElForm ref="joinFomRef" :model="joinFormData" :rules="joinFormRule">
            <section id="company-info">
                <header>
                    <h3 class="h2">公司基本資訊</h3>
                    <p>
                        請提供貴單位正確、最新的資料，且不得以第三人之名義註冊為成員。<br />
                        若有提供任何錯誤或不實的資料、或欠缺必要之資料、或有重覆註冊帳號等情事時，<br />
                        管理單位有權不經事先通知，逕行暫停或終止成員的帳號，並拒絕使用。
                    </p>
                </header>
                <main>
                    <ElFormItem label="公司全名" prop="company.name">
                        <ElInput
                            id="companyName"
                            title="公司全名"
                            v-model="joinFormData.company.name"
                            placeholder="請輸入公司全名"
                        ></ElInput>
                    </ElFormItem>
                    <ElFormItem label="統一編號" prop="company.taxId">
                        <ElInput
                            id="companyTaxId"
                            title="統一編號"
                            v-model="joinFormData.company.taxId"
                            placeholder="請輸入統一編號"
                        ></ElInput>
                    </ElFormItem>
                    <ElFormItem
                        label="公司業別"
                        prop="company.type"
                        aria-label="公司業別"
                    >
                        <input type="radio" id="companyType1" name="companyType" value="回收業" v-model="joinFormData.company.type" aria-label="回收業" title="回收業">
                        <label for="companyType1" class="radio-label">回收業</label>

                        <input type="radio" id="companyType2" name="companyType" value="處理製造業" v-model="joinFormData.company.type" aria-label="處理製造業" title="處理製造業">
                        <label for="companyType2" class="radio-label">處理製造業</label>

                        <input type="radio" id="companyType3" name="companyType" value="品牌業" v-model="joinFormData.company.type" aria-label="品牌業" title="品牌業">
                        <label for="companyType3" class="radio-label">品牌業</label>

                    </ElFormItem>
                </main>
            </section>
            <section id="user-info">
                <header>
                    <h3 class="h2">聯絡人資訊</h3>
                </header>
                <main>
                    <ElFormItem label="聯絡人姓名" prop="user.name">
                        <ElInput
                            id="name"
                            title="聯絡人姓名"
                            v-model="joinFormData.user.name"
                            placeholder="請輸入聯絡人全名"
                        ></ElInput>
                    </ElFormItem>
                    <ElFormItem label="聯絡人部門" prop="user.department">
                        <ElInput
                            id="department"
                            title="聯絡人部門"
                            v-model="joinFormData.user.department"
                            placeholder="請輸入聯絡人部門"
                        ></ElInput>
                    </ElFormItem>
                    <ElFormItem label="聯絡人職稱" prop="user.jobTitle">
                        <ElInput
                            id="jobTitle"
                            title="聯絡人職稱"
                            v-model="joinFormData.user.jobTitle"
                            placeholder="請輸入聯絡人職稱"
                        ></ElInput>
                    </ElFormItem>
                    <ElFormItem label="聯絡人電話" prop="user.phone">
                        <ElInput
                            id="phone"
                            title="聯絡人電話"
                            v-model="joinFormData.user.phone"
                            placeholder="請輸入聯絡人電話"
                        ></ElInput>
                    </ElFormItem>
                    <ElFormItem label="聯絡人信箱" prop="user.email">
                        <ElInput
                            id="email"
                            title="聯絡人信箱"
                            v-model="joinFormData.user.email"
                            placeholder="請輸入聯絡人信箱"
                        ></ElInput>
                    </ElFormItem>
                </main>
            </section>
            <section
                v-show="joinFormData.company.type === '回收業'"
                id="details-recycle-recycle"
            >
                <header>
                    <h3 class="h2">回收項目及區域</h3>
                    <p>
                        依自家公司回收項目，回收材質，允收標準，收受範圍等資訊敘明，以提供意者洽詢。
                    </p>
                </header>
                <main>
                    <ElFormItem
                        class="is-required"
                        label="回收項目"
                        prop="recycle.types"
                    >
                        <ElCheckboxGroup v-model="joinFormData.recycle.types">
                            <ElCheckbox id="r_category1" aria-label="PET寶特瓶" label="PET寶特瓶">
                                <label for="r_category1">PET寶特瓶</label>
                            </ElCheckbox>
                            <ElCheckbox id="r_category2" aria-label="PP容器" label="PP容器">
                                <label for="r_category2">PP容器</label>
                            </ElCheckbox>
                            <ElCheckbox id="r_category3" aria-label="PE容器" label="PE容器">
                                <label for="r_category3">PE容器</label>
                            </ElCheckbox>
                            <ElCheckbox id="r_category4" aria-label="PA尼龍" label="PA尼龍">
                                <label for="r_category4">PA尼龍</label>
                            </ElCheckbox>
                            <div>
                                <ElInput
                                    id="r_categoryInput"
                                    title="r_categoryInput"
                                    v-model="joinFormData.recycle.otherType"
                                    placeholder="輸入其他回收項目"
                                    aria-label="輸入其他回收項目"
                                ></ElInput>
                            </div>
                        </ElCheckboxGroup>
                    </ElFormItem>
                    <ElFormItem
                        class="is-required"
                        label="允收標準"
                        prop="recycle.allowedStandard"
                    >
                        <ElInput
                            v-model="joinFormData.recycle.allowedStandard"
                            placeholder="請輸入允收標準"
                        ></ElInput>
                    </ElFormItem>
                    <ElFormItem
                        class="is-required"
                        label="收受範圍"
                        prop="recycle.allowedRange"
                    >
                        <ElInput
                            v-model="joinFormData.recycle.allowedRange"
                            placeholder="請輸入收受範圍"
                        ></ElInput>
                    </ElFormItem>
                </main>
            </section>
            <section
                v-show="joinFormData.company.type === '處理製造業'"
                id="details-manufacture-recycle"
            >
                <header>
                    <h3 class="h2">回收項目及區域</h3>
                    <p>
                        依自家公司回收項目，回收材質，允收標準，收受範圍等資訊敘明，以提供意者洽詢。
                    </p>
                </header>
                <main>
                    <ElFormItem
                        class="is-required"
                        label="回收項目"
                        prop="recycle.types"
                    >
                        <ElCheckboxGroup v-model="joinFormData.recycle.types">
                            <ElCheckbox id="category1" aria-label="PET寶特瓶" label="PET寶特瓶">
                                <label for="category1">PET寶特瓶</label>
                            </ElCheckbox>
                            <ElCheckbox id="category2" aria-label="PP容器" label="PP容器">
                                <label for="category2">PP容器</label>
                            </ElCheckbox>
                            <ElCheckbox id="category3" aria-label="PE容器" label="PE容器">
                                <label for="category3">PE容器</label>
                            </ElCheckbox>
                            <ElCheckbox id="category4" aria-label="PA尼龍" label="PA尼龍">
                                <label for="category4">PA尼龍</label>
                            </ElCheckbox>
                            <div>
                                <ElInput
                                    id="categoryInput"
                                    title="categoryInput"
                                    v-model="joinFormData.recycle.otherType"
                                    placeholder="輸入其他回收項目"
                                    aria-label="輸入其他回收項目"
                                ></ElInput>
                            </div>
                        </ElCheckboxGroup>
                    </ElFormItem>
                </main>
            </section>
            <section
                v-show="joinFormData.company.type === '處理製造業'"
                id="details-manufacture-product"
            >
                <header>
                    <h3 class="h2">產品類型</h3>
                    <p>
                        依自家公司欲製造或生產之海洋廢棄物循環利用產品類型選擇適宜項目。
                    </p>
                </header>
                <main>
                    <ElFormItem
                        class="is-required"
                        label="產品類型"
                        prop="product.types"
                    >
                        <ElCheckboxGroup id="materialTypeSelect" v-model="joinFormData.product.types">
                            <ElCheckbox id="material1" aria-label="顆粒" label="顆粒">
                                <label for="material1">顆粒</label>
                            </ElCheckbox>
                            <ElCheckbox id="material2" aria-label="碎片" label="碎片">
                                <label for="material2">碎片</label>
                            </ElCheckbox>
                            <ElCheckbox id="material3" aria-label="薄膜" label="薄膜">
                                <label for="material3">薄膜</label>
                            </ElCheckbox>
                            <ElCheckbox id="material4" aria-label="絲線" label="絲線">
                                <label for="material4">絲線</label>
                            </ElCheckbox>
                            <div>
                                <ElInput
                                    id="materialInput"
                                    title="materialInput"
                                    v-model="joinFormData.product.otherType"
                                    placeholder="輸入其他產品類型"
                                    aria-label="輸入其他產品類型"
                                ></ElInput>
                            </div>
                        </ElCheckboxGroup>
                    </ElFormItem>
                </main>
            </section>
            <section v-show="joinFormData.company.type === '品牌業'" id="details-brand-product">
                <header>
                    <h3 class="h2">產品類型</h3>
                    <p>依自家公司欲製造或生產之海洋廢棄物循環利用產品類型選擇適宜項目。</p>
                </header>
                <main>
                    <ElFormItem class="is-required" label="產品類型" prop="product.types">
                        <ElCheckboxGroup id="productTypeSelect" v-model="joinFormData.product.types">
                            <ElCheckbox id="product1" title="家電產品" aria-label="家電產品">
                                <label for="product1">家電產品</label>
                            </ElCheckbox>
                            <ElCheckbox id="product2" title="資訊產品" aria-label="資訊產品">
                                <label for="product2">資訊產品</label>
                            </ElCheckbox>
                            <ElCheckbox id="product3" title="日常用品" aria-label="日常用品">
                                <label for="product3">日常用品</label>
                            </ElCheckbox>
                            <ElCheckbox id="product4" title="辦公室用品" aria-label="辦公室用品">
                                <label for="product4">辦公室用品</label>
                            </ElCheckbox>
                            <ElCheckbox id="product5" title="省電產品" aria-label="省電產品">
                                <label for="product5">省電產品</label>
                            </ElCheckbox>
                            <ElCheckbox id="product6" title="工業產品" aria-label="工業產品">
                                <label for="product6">工業產品</label>
                            </ElCheckbox>
                            <ElCheckbox id="product7" title="彩妝用品" aria-label="彩妝用品">
                                <label for="product7">彩妝用品</label>
                            </ElCheckbox>

                            <div>
                                <ElInput
                                    id="productInput"
                                    title="productInput"
                                    v-model="joinFormData.product.otherType"
                                    placeholder="輸入其他產品類型"
                                    aria-label="輸入其他產品類型"
                                ></ElInput>
                            </div>
                        </ElCheckboxGroup>
                    </ElFormItem>
                </main>
            </section>

            <ElFormItem>
                <div
                    class="large-btn"
                    role="button"
                    tabindex="0"
                    @click.prevent="submitForm"
                    @keypress.enter.prevent="submitForm"
                >
                    確認無誤送出
                </div>
            </ElFormItem>
        </ElForm>
    </div>
</template>
<script>
export default {
    name: 'SupplyChainJoin',
}
</script>
<script setup>
import { ref, reactive } from 'vue'
import {
    ElForm,
    ElFormItem,
    ElInput,
    // ElRadioGroup,
    // ElRadio,
    ElCheckboxGroup,
    ElCheckbox,
    ElMessageBox,
    ElLoading,
} from 'element-plus'
import '@/style/element'
import { registerSupplyChain } from '@/service/apis.js'
import { useRouter } from 'vue-router'
const router = useRouter()

const joinFomRef = ref(null)
const joinFormData = reactive({
    company: {
        name: '',
        taxId: '',
        type: '',
    },
    user: {
        name: '',
        department: '',
        jobTitle: '',
        phone: '',
        email: '',
    },
    recycle: {
        types: [],
        otherType: '',
        allowedStandard: '',
        allowedRange: '',
    },
    product: {
        types: [],
        otherType: '',
    },
})
const joinFormRule = reactive({
    company: {
        name: [
            {
                required: true,
                message: '公司全名為必填項目',
                trigger: 'blur',
            },
        ],
        taxId: [
            {
                required: true,
                message: '統一編號為必填項目',
                trigger: 'blur',
            },
            {
                validator: (rule, value, callback) => {
                    let taxIdRegex = new RegExp(/^\d{8}$/)
                    if (!taxIdRegex.test(value)) {
                        callback(new Error('統一編號格式有誤'))
                    } else {
                        callback()
                    }
                },
                trigger: 'blur',
            },
        ],
        type: [
            {
                required: true,
                message: '公司業別為必填項目',
                trigger: 'blur',
            },
        ],
    },
    user: {
        name: [
            {
                required: true,
                message: '聯絡人姓名為必填項目',
                trigger: 'blur',
            },
        ],
        phone: [
            {
                required: true,
                message: '聯絡人電話為必填項目',
                trigger: 'blur',
            },
        ],
        email: [
            {
                required: true,
                message: '聯絡人信箱為必填項目',
                trigger: 'blur',
            },
            {
                type: 'email',
                message: '信箱格式有誤',
                trigger: 'blur',
            },
        ],
    },
    recycle: {
        types: [
            {
                validator: (rule, value, callback) => {
                    if (
                        (joinFormData.company.type === '回收業' ||
                            joinFormData.company.type === '處理製造業') &&
                        value.length === 0 &&
                        joinFormData.recycle.otherType === ''
                    ) {
                        callback(new Error('回收項目為必填項目'))
                    } else {
                        callback()
                    }
                },
                trigger: 'submit',
            },
        ],
        allowedStandard: [
            {
                validator: (rule, value, callback) => {
                    if (
                        joinFormData.company.type === '回收業' &&
                        value === ''
                    ) {
                        callback(new Error('允收標準為必填項目'))
                    } else {
                        callback()
                    }
                },
                trigger: 'blur',
            },
        ],
        allowedRange: [
            {
                validator: (rule, value, callback) => {
                    if (
                        joinFormData.company.type === '回收業' &&
                        value === ''
                    ) {
                        callback(new Error('允收範圍為必填項目'))
                    } else {
                        callback()
                    }
                },
                trigger: 'blur',
            },
        ],
    },
    product: {
        types: [
            {
                validator: (rule, value, callback) => {
                    if (
                        (joinFormData.company.type === '品牌業' ||
                            joinFormData.company.type === '處理製造業') &&
                        value.length === 0 &&
                        joinFormData.recycle.otherType === ''
                    ) {
                        callback(new Error('產品類型為必填項目'))
                    } else {
                        callback()
                    }
                },
                trigger: 'submit',
            },
        ],
    },
})
const submitForm = () => {
    joinFomRef.value.validate(async (valid) => {
        if (valid) {
            let loadingInstance = ElLoading.service()
            try {
                await registerSupplyChain(joinFormData)
                loadingInstance.close()
                ElMessageBox.alert(
                    '您的申請已經提交，會有專人再與您聯繫！',
                    '提交完成',
                    {
                        confirmButtonText: 'OK',
                        callback: () => {
                            router.push({ name: 'Home' })
                        },
                    }
                )
            } catch {
                loadingInstance.close()
                console.log('error')
            }
        } else {
            return false
        }
    })
}
</script>
<style lang="scss" scoped>
section {
    margin-bottom: 50px;
}
header {
    margin-bottom: 10px;
    p {
        color: $grayB;
        font-size: 12px;
        line-height: 1.5em;
        letter-spacing: 0.03em;
    }
}
.large-btn {
    margin-bottom: 60px;
}
.el-form:deep() {
    .el-form-item {
        position: relative;
        display: block;
        &.is-required > .el-form-item__label:before {
            position: absolute;
            left: -8px;
            top: 0;
        }
        .el-form-item__label {
            color: $gray6;
            font-weight: 700;
            letter-spacing: 0.05em;
        }
    }
    .el-input {
        max-width: 300px;
    }
    // .el-radio {
    //     height: auto;
    //     margin-right: 16px;
    //     margin-bottom: 10px;
    //     &:focus-within {
    //         outline: auto;
    //     }
    //     .el-radio__input {
    //         display: none;
    //         opacity: 0;
    //     }
    //     .el-radio__label {
    //         border: 1px solid $grayD;
    //         text-align: center;

    //         padding: 10px 15px;
    //         border-radius: 10px;
    //         transition: 0.3s;
    //         .img-wrap {
    //             display: flex;
    //             justify-content: center;
    //             align-items: center;
    //             img {
    //                 margin: 10px;
    //             }
    //         }
    //         p {
    //             color: $gray6;
    //             font-size: 16px;
    //             font-weight: 700;
    //             line-height: 2em;
    //             letter-spacing: 0.05em;
    //         }
    //         @media screen and (min-width: 768px) {
    //             min-width: 120px;
    //             .img-wrap {
    //                 height: 80px;
    //             }
    //             img {
    //                 max-width: 120px;
    //                 max-height: 60px;
    //             }
    //         }
    //         @media screen and (max-width: 767px) {
    //             min-width: 80px;
    //             .img-wrap {
    //                 height: 50px;
    //             }
    //             img {
    //                 max-width: 60px;
    //                 max-height: 40px;
    //             }
    //         }
    //     }

    //     &.is-checked {
    //         .el-radio__label {
    //             border-color: $gray6;
    //         }
    //     }
    // }
}
</style>
